import React, { useEffect, useState } from 'react'
import { useForm, type SubmitHandler } from 'react-hook-form'
import './edit-pre-order.css'
import AdminButton from '../../utils/adminButton/AdminButton'
import InfoModal from '../../utils/infoModal/InfoModal'
import { type ProductType } from '../../../utils/types'
import preOrderService from '../../../services/preOrderService'
interface EditPreOrderProps {
  onEditPreOrder: (preOrder: any) => void
  closeModal: () => void
  preOrderProp: Partial<ProductType>
}

const EditPreOrder: React.FC<EditPreOrderProps> = ({
  preOrderProp,
  onEditPreOrder,
  closeModal
}) => {
  const {
    register,
    watch,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm<ProductType>({
    defaultValues: {
      id: preOrderProp.id,
      Audience: preOrderProp.Audience,
      code: preOrderProp.code,
      label: preOrderProp.label,
      deliveryDate: preOrderProp.deliveryDate
    }
  })
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalText, setModalText] = useState('')
  const [shouldCloseModal, setShouldCloseModal] = useState(false)

  const idProduit = watch('id')

  useEffect(() => {
    if (idProduit > 0) {
      preOrderService
        .getPreOrdersById(idProduit)
        .then((data: ProductType) => {
          const formattedDate = data.deliveryDate
            ? new Date(data.deliveryDate).toISOString().split('T')[0]
            : ''
          setValue('Audience', data.Audience)
          setValue('code', data.code)
          setValue('label', data.label)
          setValue('deliveryDate', formattedDate as any) // Force `setValue` to accept string
        })
        .catch(() => {
          setValue('Audience', null)
          setValue('code', '')
          setValue('label', '')
          setValue('deliveryDate', new Date().toISOString().split('T')[0] as any) // Same as above
        })
    } else {
      setValue('Audience', null)
      setValue('code', '')
      setValue('label', '')
      setValue('deliveryDate', new Date().toISOString().split('T')[0] as any) // Same as above
    }
  }, [idProduit, setValue])

  const onSubmit: SubmitHandler<ProductType> = (data: ProductType) => {
    data.Audience = data.Audience && data.Audience.id === -1 ? null : data.Audience
    if (data.deliveryDate) {
      preOrderService
        .createPreOrder(data.id, data.deliveryDate)
        .then((res) => {
          setModalText('Le pre-order a été modifié avec succès')
          setIsModalOpen(true)
          onEditPreOrder(res)
          setShouldCloseModal(true)
        })
        .catch(() => {
          setModalText('Une erreur est survenue lors de la création du pre-Order')
          setIsModalOpen(true)
        })
    }
  }

  return (
    <>
      <form className='audience-form' onSubmit={handleSubmit(onSubmit)}>
        <div className='inputs-container'>
        <div className='input-form-container'>
            <p className='input-label'>ID Produit</p>
            <input
              className='input-text'
              type='number'
              {...register('id', {
                min: {
                  value: 0,
                  message: 'Les caractères saisis sont incorrects'
                }
              })}
              disabled
            />
            {errors.minToOrder && (
              <p className='validation-error'>{errors.minToOrder.message}</p>
            )}
          </div>
          <div className='input-form-container'>
            <p className='input-label'>Audience</p>
            <input
              className='input-text'
              {...register('Audience.name', {
                required: 'Ce champ est obligatoire'
              })}
              disabled
            />
            {errors.code && (
              <p className='validation-error'>{errors.code.message}</p>
            )}
          </div>
          <div className='input-form-container'>
            <p className='input-label'>Code Produit</p>
            <input
              className='input-text'
              {...register('code', {
                required: 'Ce champ est obligatoire'
              })}
              disabled
            />
            {errors.code && (
              <p className='validation-error'>{errors.code.message}</p>
            )}
          </div>
          <div className='input-form-container'>
            <p className='input-label'>Libellé Pre-Order</p>
            <input
              className='input-text'
              {...register('label', {
                required: 'Ce champ est obligatoire'
              })}
              disabled
            />
            {errors.label && (
              <p className='validation-error'>{errors.label.message}</p>
            )}
          </div>
          <div className='input-form-container full-width'>
            <p className='input-label'>Date de Livraison</p>
            <input
              type='date'
              className='input-text input-date-pre-order'
              {...register('deliveryDate', {
                required:
                  'Ce champ est obligatoire'
              })}
            />
            {errors.deliveryDate && (
              <p className='validation-error'>{errors.deliveryDate.message}</p>
            )}
          </div>
        </div>
        <AdminButton type='submit'>Valider</AdminButton>
      </form>
      <InfoModal
        isOpen={isModalOpen}
        title='Modifier un nouveau pre-order'
        message={modalText}
        onClose={() => {
          setIsModalOpen(false)
          if (shouldCloseModal) {
            closeModal()
          }
        }}
      />
    </>
  )
}

export default EditPreOrder
